import { render, staticRenderFns } from "./CounselorsForAppt.vue?vue&type=template&id=21e7f970"
import script from "./CounselorsForAppt.vue?vue&type=script&lang=js"
export * from "./CounselorsForAppt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports